import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Brands from '../../components/layouts/Brands';
import notion from '../../images/notion.png';
import github from '../../images/github.png';
import altasian from '../../images/altasian.png';
import gsuite from '../../images/gsuite.png';
import slack from '../../images/slack.png';
import trello from '../../images/trello.png';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = Brands;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h2>{`One click integrations`}</h2>
    <ul>
      <li parentName="ul"><img src={notion} alt="Notion" /></li>
      <li parentName="ul"><img src={github} alt="GitHub" /></li>
      <li parentName="ul"><img src={slack} alt="Slack" /></li>
      <li parentName="ul"><img src={trello} alt="Trello" /></li>
      <li parentName="ul"><img src={gsuite} alt="Google Suite" /></li>
      <li parentName="ul"><img src={altasian} alt="Altasian, Jira, and Confluence" /></li>
    </ul>


    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      